module.exports = __webpack_public_path__ + "img/lr.8ab088bd.jpg";